/**
 * enums + specialised geodata shapes.
 *
 * Mirrors `apps/safecurves/interfaces.ts`: the generic shapes live in
 * `#lib/types.ts`; this file declares the app-specific enums and the
 * narrow `ILinksSystemLayers` / `ILinksSummaryData` shapes the rest of the
 * app code consumes.
 */

import type { ILayerSource, IFeature as IGenericFeature } from '#lib/types.js';

export enum EAbleyLinksModule {
	core = 'core'
}

export enum EProduct {
	AbleyLinks = 'AbleyLinks'
}

export enum ELinksCore {
	Aadt = 'AADT Bands',
	Counts = 'Traffic counts'
}

/** operational feature — generic IFeature parameterised with EProduct + EAbleyLinksModule. */
export type ILinksFeature = IGenericFeature<EProduct, EAbleyLinksModule>;

export type ILinksSystemLayers = {
	[EAbleyLinksModule.core]: {
		[ELinksCore.Aadt]: ILayerSource | null;
		[ELinksCore.Counts]: ILayerSource | null;
	};
};

export interface ILinksSummaryData {
	location_label: string;
	[EAbleyLinksModule.core]: Record<string, string | number>[];
}
